import classNames from "classnames";

import { HeaderNavLink, HeaderNavLinkProps } from "./HeaderNavLink";

interface HeaderNavItemProps extends HeaderNavLinkProps {
  divClassName?: string;
}

export const HeaderNavItem: React.FC<HeaderNavItemProps> = ({ divClassName, ...props }) => {
  return (
    <div className={classNames("sbb-header-nav-item", divClassName, props.isSelected ? "active" : "")}>
      <HeaderNavLink {...props} />
    </div>
  );
};
